/**
 * Build a concatened URL with a base URL and a path.
 *
 * @param baseUrl the base URL.
 * @param path the path of the URL.
 * @returns returns the concatenated URL.
 */
export function buildUrl (baseUrl: string = '', path: string = '') {
  const baseLastChar = baseUrl.charAt(baseUrl.length - 1)
  const pathFirstChar = path.charAt(0)
  if (baseLastChar !== '/') {
    baseUrl += '/'
  }
  if (pathFirstChar === '/') {
    path = path.substring(1)
  }
  return `${baseUrl}${path}`
}
